<template>
    <div>
        <section class="Pages">
            <header class="pageHeader">
                <div class="sub-TitlePage">{{ $t('submitting.tourSchool.subtitlePage') }}</div>
                <ul class="linkList d-flex flex-row">
                    <li>
                        <router-link :to="`/`">{{ $t('submitting.tourSchool.linkList.item1') }}</router-link>
                    </li>
                    <li class="line"></li>
                    <li>
                        <router-link to="">{{ $t('submitting.tourSchool.linkList.item2') }}</router-link>
                    </li>
                    <li class="line"></li>
                    <li>
                        <router-link to="">{{ $t('submitting.tourSchool.linkList.item3') }}</router-link>
                    </li>
                </ul>
                 <div class="overlay"></div>
                <img class="imgHeader" src="image/image-from-rawpixel-id-99936-jpeg.webp" alt="" lazy="loading"/>
                <img class="shareIcon" src="image/share.svg" width="100%" @click="hoverShare"/>
                <div class="shareList" :class="{'slide':slide}">
                 <ul>
                <li><a href="http://twitter.com/share?url=https://www.theroyalschool.com/TourSchool"  class="twitter">Twitter</a></li>
                <li><a href="https://www.facebook.com/sharer/sharer.php?u=https://www.theroyalschool.com/TourSchool" target="_blank" class="facebook">Facebook</a></li>
                <li><a href="mailto:?subject=I wanted you to see this site&amp;body=Check out this site https://www.theroyalschool.com/TourSchool" class="email">Email Link</a></li>
                </ul>
                </div>
            </header>

            <div class="contentPage">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="9">
                            <ul class="d-flex flex-column align-start">
                                <li class="textContent">
                                    {{ $t('submitting.tourSchool.contentPage.item1') }}
                                </li>
                                <li class="textContent">
                                    {{ $t('submitting.tourSchool.contentPage.item2') }}
                                </li>
                                <ul class="d-flex flex-row">
                                    <li class="textContent">{{ $t('submitting.tourSchool.contentPage.item3') }}</li>
                                    <li class="titleContent">{{ $t('submitting.tourSchool.contentPage.item4') }}</li>
                                    <li class="textContent">{{ $t('submitting.tourSchool.contentPage.item5') }}</li>
                                    <li class="titleContent">{{ $t('submitting.tourSchool.contentPage.item6') }}</li>
                                </ul>
                                <li class="textContent">(9647733332641+ / 9647733332656+)</li>
                                <ul class="d-flex flex-row">
                                    <li class="textContent">{{ $t('submitting.tourSchool.contentPage.item7') }}</li>
                                    <li class="titleContent" style="text-decoration: underline !important;" @click="toggleView" ><div class="titleContent"> {{ $t('submitting.tourSchool.contentPage.item8') }}  </div></li>
                                </ul>
                                <ul>
                                <Transition>
                                <div class="videoSection" v-if="view">
                                
                                 <iframe
                                src="https://player.vimeo.com/video/732443631?h=ec964b416e&title=0&byline=0&portrait=0"
                                frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                                allowfullscreen></iframe>
                                </div>
                                </Transition>

                                </ul>

                            </ul>
                        </v-col>
                        <v-col cols="12" md="3" class="d-flex flex-column justify-end">
                            <div class="titlePage">
                                <ul class="d-flex flex-column align-end">
                                    <li>
                                        <router-link to="">{{ $t('submitting.tourSchool.titlePage') }}</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="navPage">
                                <ul class="d-flex flex-column align-end">
                                    <li class="linkPage">
                                        <router-link  :to="`/AdmissionProcedures`">{{ $t('submitting.tourSchool.linkPage.item1') }}</router-link>
                                    </li>
                                    <li class="linkPage">
                                        <router-link  :to="`/RegisterFees`">{{ $t('submitting.tourSchool.linkPage.item2') }}</router-link>
                                    </li>
                                    <li class="linkPage activeLink">
                                        <router-link to="">{{ $t('submitting.tourSchool.linkPage.item3') }}</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="otherLink">
                                <p>{{ $t('submitting.tourSchool.otherLink.title') }}</p>
                                <ul class="d-flex flex-column align-end">
                                    <li>
                                        <ul class="d-flex flex-row align-center">
                                            <li>
                                                <router-link  :to="`/AdmissionProcedures`">
                                                    <p>{{ $t('submitting.tourSchool.otherLink.item1') }}</p>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link  :to="`/AdmissionProcedures`">
                                                    <div class="img size"><img src="image/clipboard.svg"/></div>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <ul class="d-flex flex-row">
                                            <li>
                                                <router-link :to="`/BuildSchool`">
                                                    <p>{{ $t('submitting.tourSchool.otherLink.item2') }}</p>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="`/BuildSchool`">
                                                    <div class="img size"><img src="image/school-svgrepo-com.svg"/></div>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <ul class="d-flex flex-row">
                                            <li>
                                                <router-link :to="`/Steam`">
                                                    <p>{{ $t('submitting.tourSchool.otherLink.item3') }} </p>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="`/Steam`">
                                                    <div class="img size"><img src="image/globalEducation.svg"/></div>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <ul class="d-flex flex-row">
                                            <li>
                                                <router-link :to="`/ContactUs`">
                                                    <p>{{ $t('submitting.tourSchool.otherLink.item4') }}</p>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="`/ContactUs`">
                                                    <div class="img size"><img src="image/phone.svg"/></div>
                                                </router-link>
                                            </li>
                                        </ul>

                                    </li>
                                </ul>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </section>
    </div>

</template>
<script>
  export default {
    data() {
      return {
          slide:null,
          view:false
          
      }
    },
    methods:{
        toggleView(){
            this.view = !this.view;
        },
        hoverShare() {
          this.slide = !this.slide; 
        }
    },
  }
</script>
